import { render } from "./sidebar_user_footer.html?vue&type=template&id=1c928895&external"
import script from "./sidebar_user_footer.js?vue&type=script&lang=js&external"
export * from "./sidebar_user_footer.js?vue&type=script&lang=js&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__